import { useState } from 'react';
import { Common, color } from '@stockbit/ui';

import Image from 'global/Image';
import {
  NotationPopoverWrapper,
  NotationCodeBox,
  NotationDesc,
} from './styled';

const { Text, Flex } = Common;

function NotationPopover({ data }) {
  const [isShown, setIsShown] = useState(false);

  const { notation, symbol, name } = data;

  return (
    <Flex
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      <Image src="/icon/ic_indicator.svg" alt="warning" width="12px" />
      {isShown && (
        <NotationPopoverWrapper>
          <Flex align="center">
            <Text size="24px" family="bold" align="center" mr="5px">
              {symbol}
            </Text>
            <Image src="/icon/ic_indicator.svg" alt="warning" width="12px" />
          </Flex>
          <Text align="center">{name}</Text>
          <Text align="center" padding="15px">
            Perusahaan memiliki notasi khusus sebagai berikut:
          </Text>
          <Flex direction="column">
            {notation.map((item) => {
              return (
                <Flex align="center" justify="center" padding="5px 10px">
                  <NotationCodeBox>
                    <Text color="#eba031">{item.notation_code}</Text>
                  </NotationCodeBox>
                  <NotationDesc>{item.notation_desc}</NotationDesc>
                </Flex>
              );
            })}
          </Flex>
        </NotationPopoverWrapper>
      )}
    </Flex>
  );
}

export default NotationPopover;
